(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nordskal-header"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('nordskal-navigation')) {
  customElements.define('nordskal-navigation', class extends HTMLElement {
    connectedCallback() {
      if (this.menuReady) return;
      this.toggleButton = this.querySelector('[data-ns-menu-toggle]');
      this.navigation = this.querySelector('[data-ns-menu]');
      if (!this.toggleButton || !this.navigation) return;
      this.mobileMedia = window.matchMedia('(max-width: 749px)');
      this.onMenuToggle = () => this.setExpanded(this.toggleButton.getAttribute('aria-expanded') !== 'true');
      this.onViewportChange = () => {
        const focusWasOnToggle = document.activeElement === this.toggleButton;
        const focusWasInNavigation = this.navigation.contains(document.activeElement);
        this.toggleButton.hidden = !this.mobileMedia.matches;
        this.setExpanded(!this.mobileMedia.matches);
        if (this.mobileMedia.matches && focusWasInNavigation) this.toggleButton.focus();
        else if (!this.mobileMedia.matches && focusWasOnToggle) this.navigation.querySelector('a[href]')?.focus();
      };
      this.onMenuLinkClick = (event) => {
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const link = event.target.closest?.('a[href]');
        if (!link || !this.navigation.contains(link) || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
        if (this.mobileMedia.matches) this.setExpanded(false);
        const targetUrl = new URL(link.href, window.location.href);
        if (targetUrl.origin === window.location.origin && targetUrl.pathname === window.location.pathname && targetUrl.search === window.location.search && targetUrl.hash) {
          const target = document.getElementById(decodeURIComponent(targetUrl.hash.slice(1)));
          target?.focus({ preventScroll: true });
        }
      };
      this.onMenuKeydown = (event) => {
        if (event.key === 'Escape' && this.mobileMedia.matches && !this.navigation.hidden && (this.navigation.contains(event.target) || this.toggleButton.contains(event.target))) {
          this.setExpanded(false);
          this.toggleButton.focus();
          event.preventDefault();
        }
      };
      this.toggleButton.addEventListener('click', this.onMenuToggle);
      this.navigation.addEventListener('click', this.onMenuLinkClick);
      this.mobileMedia.addEventListener('change', this.onViewportChange);
      this.addEventListener('keydown', this.onMenuKeydown);
      this.menuReady = true;
      this.onViewportChange();
      this.cartLink = this.querySelector('[data-ns-cart-link]');
      this.cartCount = this.querySelector('[data-ns-cart-count]');
      const connection = {};
      this.cartConnection = connection;
      this.cartUpdateRevision = 0;
      this.onCartUpdate = (event) => {
        const revision = ++this.cartUpdateRevision;
        event.promise?.then(({ cart }) => {
          if (!this.isConnected || this.cartConnection !== connection || revision !== this.cartUpdateRevision) return;
          // totalQuantity is the cart total; the add event's detail.itemCount is only the added quantity.
          const count = cart?.totalQuantity;
          if (!Number.isInteger(count) || count < 0 || !this.cartLink || !this.cartCount) return;
          this.cartCount.textContent = String(count);
          this.cartLink.setAttribute('aria-label', this.cartLink.dataset.cartLabelTemplate.replace('__COUNT__', String(count)));
        }).catch(() => {});
      };
      import('@shopify/events').then(({ StandardEvents }) => {
        if (!this.isConnected || this.cartConnection !== connection) return;
        this.cartUpdateEvent = StandardEvents.cartLinesUpdate;
        document.addEventListener(this.cartUpdateEvent, this.onCartUpdate);
      }).catch(() => {});
    }
    disconnectedCallback() {
      if (!this.menuReady) return;
      this.toggleButton.removeEventListener('click', this.onMenuToggle);
      this.navigation.removeEventListener('click', this.onMenuLinkClick);
      this.mobileMedia.removeEventListener('change', this.onViewportChange);
      this.removeEventListener('keydown', this.onMenuKeydown);
      if (this.cartUpdateEvent) document.removeEventListener(this.cartUpdateEvent, this.onCartUpdate);
      this.cartConnection = null;
      this.menuReady = false;
    }
    setExpanded(expanded) {
      this.navigation.hidden = !expanded;
      this.toggleButton.setAttribute('aria-expanded', String(expanded));
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
